import type { SearchEntry } from "./api";
import { LEAGUES } from "../shell/leagues";

/** The rows of a signed-out visitor's stored searches worth showing: well-formed, of a kind and league the site has.
 *  Every league in LEAGUES counts, so a EuroLeague or G League pick survives the next save (Q675-01). */
export function deviceSearchRows(rows: unknown): SearchEntry[] {
  if (!Array.isArray(rows)) return [];
  return rows.filter((r): r is SearchEntry =>
    !!r && typeof r === "object" && typeof (r as SearchEntry).id === "number" && typeof (r as SearchEntry).ref === "string"
    && typeof (r as SearchEntry).label === "string" && ["team", "player", "fighter"].includes((r as SearchEntry).kind)
    && LEAGUES.some((l) => l.key === (r as SearchEntry).league));
}
